import {  useState } from "react";
import { useNavigate } from "react-router-dom";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import QuantitySelector from './QuantitySelector';



const PurchasableItem = ({ name, price, imgUrl, vmId }) => {
    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(1);

    const minQuantity = 1;
    const maxQuantity = 5;

    const handleDecrement = () => {
        if (quantity > minQuantity) {
        setQuantity(quantity - 1);
        }
    };

    const handleIncrement = () => {
        if (quantity < maxQuantity) {
        setQuantity(quantity + 1);
        }
    };

    const handleBuyNow = (quantity) => {
        navigate("/checkout", { state: { vmId, quantity } });
    };

    return (
        <Card sx={{ minWidth: "70%", m: 3,
                borderRadius: '16px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                background: 'rgba(255, 255, 255, 1)',
        }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'center', m: 2 }}>
                    <Box
                        component="img"
                        src={imgUrl}
                        sx={{
                            maxWidth: '80%',
                            maxHeight: "30vh",
                            objectFit: 'cover',
                            borderRadius: '12px',
                        }}
                    />
                </Box>
                <Typography color='text.primary' variant="h5" component="div" sx={{ textAlign: 'center', fontWeight: 400 , mx: 1}}>
                    {name}
                </Typography>
                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                        <Typography variant="h4" sx={{ fontWeight: 600 }}>
                            €{price}
                        </Typography>
                    </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", my: 2 }}>
                    <QuantitySelector minQuantity={minQuantity} maxQuantity={maxQuantity} handleDecrement={handleDecrement} handleIncrement={handleIncrement} quantity={quantity} />
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => handleBuyNow(quantity)}
                        sx={{
                            // shine variables
                            '--shine-degree': '120deg',
                            '--shine-color': 'rgba(255, 255, 255, 0.2)',
                            '--shine-speed': '1s', // active shine duration
                            '--shine-pause': '3s', // desired pause between shines
                            '--shine-effect': 'linear-gradient(var(--shine-degree), transparent, var(--shine-color), transparent)',
                            '--shine-transition': 'all var(--shine-speed) ease-in-out',

                            position: 'relative',
                            overflow: 'hidden',
                            backgroundColor: '#2e6f40',
                            fontWeight: 'bold',
                            fontSize: '1.8rem',
                            borderRadius: '80px',
                            padding: '10px 30px',

                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: '-75%',
                                width: '50%',
                                height: '100%',
                                background: 'var(--shine-effect)',
                                transform: 'skewX(-20deg)',
                                filter: 'blur(5px)',
                                opacity: 0.85,
                                pointerEvents: 'none',
                                // total animation duration = shine duration + pause
                                animation: 'shine calc(var(--shine-speed) + var(--shine-pause)) ease-in-out infinite'
                            },

                            '@keyframes shine': {
                                '0%': { left: '-100%' },
                                '50%': { left: '100%' },
                                // immediately hide it for the pause
                                '50.1%': { opacity: 0 },
                                '100%': { left: '100%', opacity: 0 }
                            }
                        }}
                    >
                        Buy
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
    };

    export default PurchasableItem;
